import "./svg/kalkun.svg"

export default {
    name: "kalkun",
    viewBox: "124 68",
}
